import React, { useCallback, useEffect } from 'react';
import LayoutWithMap from 'containers/Base/LayoutWithMap.jsx';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import useFilters from 'containers/Base/useFilters';
import { detailOpenState, modalState, toggleModal } from 'reducers/ui';
import { getUserAssignedDepartmentList } from 'reducers/users';
import { getCompanyAssetCategories } from 'reducers/securityCompany';
//specific asset type imports
import * as assetTypeSelectors from '../Selectors/assetTypeSelectors';
import { actions as assetTypeActions } from '../Modules/dataGridTable';
import { actions as assetTypeFilterActions } from '../Modules/filters';
import { nameSpace } from '../Modules/nameSpace';
import { filters } from '../filters';
import { refreshAssetTypeDetails } from '../Actions/assetTypePageActions';
import { PAGE_URLS } from 'utils/constants';

const AssetType = ({
  columns,
  filtersRequired,
  FormComponent,
  editable,
  details,
  loading,
  allowableCategories,
}) => {
  //---------------------------Selectors---------------------------
  const assetTypeListData = useSelector(state =>
    assetTypeSelectors.getAssetTypeListTransformed(state),
  );
  const totalEntries = useSelector(state =>
    assetTypeSelectors.getTotalRowsCount(state),
  );
  const filterValues = useSelector(state =>
    assetTypeSelectors.getAssetTypeFilters(state),
  );
  const forceRefresh = useSelector(state =>
    assetTypeSelectors.getForceRefresh(state),
  );
  const modalOpen = useSelector(state => modalState(state));

  const userAssignedDepartments = useSelector(state =>
    getUserAssignedDepartmentList(state),
  );
  const assetTypeDetails = useSelector(state =>
    assetTypeSelectors.getAssetTypeDetailsTransformed(state),
  );
  const detailOpen = useSelector(state => detailOpenState(state));
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();
  const dispatchFetchAssetTypesList = useCallback(
    ({ filters, from }) =>
      dispatch(assetTypeActions.fetchGridList({ filters, from })),
    [dispatch],
  );

  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(nameSpace)),
    [dispatch],
  );
  //----------------------------------------------------------------
  const onUpdate = filters => {
    dispatchFetchAssetTypesList({
      filters,
    });
  };
  const fetchAssetTypes = from => {
    dispatchFetchAssetTypesList({
      filters: localFilterValues,
      from,
    });
  };
  const AssetTypeFormComponent = useCallback(
    props => (
      <FormComponent
        {...props}
        userAssignedDepartments={userAssignedDepartments}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  useEffect(() => {
    if (Object.keys(assetTypeDetails).length) {
      dispatch(refreshAssetTypeDetails());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetTypeListData]);
  return (
    <LayoutWithMap
      header="Asset Types"
      cols={columns}
      data={assetTypeListData}
      totalEntries={totalEntries}
      loading={loading}
      forceRefresh={forceRefresh}
      //details
      DetailComponent={details}
      //creating and editing
      editable={editable}
      FormComponent={AssetTypeFormComponent}
      toggleModal={dispatchToggleModal}
      onEdit={modalOpen[nameSpace]}
      //filters
      filtersRequired={filtersRequired}
      filterValues={localFilterValues}
      filters={filters({ allowableCategories })}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            dispatch(assetTypeFilterActions.setFilterKey(true));
            dispatch(assetTypeFilterActions.setFilters({ filters }));
          },
        })
      }
      //end-filters
      onUpdate={onUpdate}
      fetchData={fetchAssetTypes}
      //setGridAPI={gridAPIHandler}
      persistentStateName={PAGE_URLS.ASSET_TYPES.name}
      forceOpenDetailPanel={detailOpen[PAGE_URLS.ASSET_TYPES.link]}
    />
  );
};

AssetType.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  FormComponent: PropTypes.elementType,
  userAssignedDepartments: PropTypes.array,
  allowableCategories: PropTypes.array,
};
const mapStateToProps = state => ({
  allowableCategories: getCompanyAssetCategories(state),
});

export default connect(mapStateToProps)(AssetType);
